import React from 'react';
import { SignUpForm } from './SignUp';

export default function Login() {
  return <SignUpForm />;
}
